import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth-routes/admin/organizations')({
  beforeLoad: () => {
    throw redirect({ to: '/admin/organization' })
  },
})
